import type {Raid} from "../rest/RaidSchema.ts";
import {Skeleton, Tag, Typography} from "antd";
import {formatDateTime} from "@/helpers/dateFormatHelper.ts";
import {localizedNumberFormatter} from "@/helpers/numberFormatHelper.tsx";

type Props = {
  raid: Raid;
};

export function MobileColumnComponent({raid}: Props) {
  return (
      <div>
        <Typography.Title level={5}>{raid.name}</Typography.Title>
        <div className={"flex gap-2"}>
          <div className={"flex-1 flex flex-col gap-1 min-w-0"}>
            {raid.endTime && <Tag className={"whitespace-normal! shadow-[var(--custom-box-shadow)]"} color="volcano">Beendet
              am {formatDateTime(raid.endTime)}</Tag>}
            {raid.startTime && !raid.endTime &&
                <Tag className={"whitespace-normal! shadow-[var(--custom-box-shadow)]"} color="green">Laufend</Tag>}
            {!raid.startTime && !raid.endTime &&
                <Tag className={"whitespace-normal! shadow-[var(--custom-box-shadow)]"} color="geekblue">In Vorbereitung</Tag>}
            <Tag color="default">
              <div className={"flex-1 flex justify-between"}>
                <div>Teilnehmer:</div>
                <div>{localizedNumberFormatter(raid.participants.length)}</div>
              </div>
            </Tag>
          </div>
          <div className={"flex-1 flex flex-col gap-1 min-w-0"}>
            <Tag color="default">
              <div className={"flex-1 flex justify-between"}>
                <div>Spice:</div>
                <div>{localizedNumberFormatter(raid.spiceReadOnly)}</div>
              </div>
            </Tag>
            <Tag color="default">
              <div className={"flex-1 flex justify-between"}>
                <div>Titanium:</div>
                <div>{localizedNumberFormatter(raid.titaniumReadOnly)}</div>
              </div>
            </Tag>
            <Tag color="default">
              <div className={"flex-1 flex justify-between"}>
                <div>Stravidium:</div>
                <div>{localizedNumberFormatter(raid.stravidiumReadOnly)}</div>
              </div>
            </Tag>
          </div>
        </div>
      </div>
  );
}

export function MobileColumnComponentSkeleton() {
  return (
      <div className={"flex gap-2 flex-col"}>
        <Skeleton.Button active size="small" block />
        <div className={"flex gap-2"}>
          <div className={"flex-1 flex flex-col gap-1 min-w-0"}>
            <Skeleton.Button active size="small" block />
            <Skeleton.Button active size="small" block />
          </div>
          <div className={"flex-1 flex flex-col gap-1 min-w-0"}>
            <Skeleton.Button active size="small" block />
            <Skeleton.Button active size="small" block />
            <Skeleton.Button active size="small" block />
          </div>
        </div>
      </div>
  );
}
